module.exports = __webpack_public_path__ + "static/media/destaque-produtos-linhas-mobile.82216f8c.jpg";